import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "t-head" }
const _hoisted_5 = { class: "tr" }
const _hoisted_6 = { class: "t-body" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4 flex-1 d-flex flex-column" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_my_card_body, { style: {"height":"100%","display":"flex"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.thead, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "td",
                      key: item
                    }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (r, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tr",
                      key: i
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r, (d) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "td",
                          key: d
                        }, [
                          ($setup.Type.IMAGE === d.type)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: d.value,
                                alt: ""
                              }, null, 8, _hoisted_7))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(d.value), 1)
                              ], 64))
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}